import React from 'react';
import SimpleLoader from 'components/loader/SimpleLoader';
import useDatasetInformation from '../hooks/useDatasetInformation';
import { NLink } from '@innersource-nn/novoui-react';

const DatasetInformation = () => {
    const {
        displayData,
        description,
        datasetLabel,
        datasetUri,
        loading,
        error,
    } = useDatasetInformation();

    return (
        <div className="text-true-blue">
            <h3 className="text-2xl font-bold">{datasetLabel}</h3>
            <p>{description}</p>
            {loading ? (
                <SimpleLoader />
            ) : (
                Object.keys(displayData)?.length !== 0 && (
                    <div className="grid grid-cols-2 xl:grid-cols-4 gap-y-24 mt-16">
                        {displayData.map((field, index) => (
                            <div key={index}>
                                <b>{field.label}</b>
                                <p className="font-extralight">
                                    {field.label === 'Dataset' ? (
                                        <NLink href={`/dataset/${datasetUri}`}>
                                            {field.value}
                                        </NLink>
                                    ) : (
                                        field.value
                                    )}
                                </p>
                            </div>
                        ))}
                    </div>
                )
            )}
        </div>
    );
};
export default DatasetInformation;
